import script from "./digitalzone-detail.vue?vue&type=script&lang=tsx&setup=true"
export * from "./digitalzone-detail.vue?vue&type=script&lang=tsx&setup=true"

import "./digitalzone-detail.vue?vue&type=style&index=0&id=1862c8d2&lang=scss"

const __exports__ = script;

export default __exports__